module.exports = __webpack_public_path__ + "images/branding/IMR-2-0-Modified-White.png";